
import PropTypes from "prop-types";
import * as React from "react";
import classNames from "classnames";
import some from "lodash/some";

import { TooltipBody } from "components";
import { DivTooltip, Menu } from "@wg/wows-react-uikit";
import settings from "settings";
import { t } from "helpers/localization";
import styles from "./RealmDropdown.scss";
import { TYPE_GLOBAL_SEARCH } from "../../../Actions/ActionClanRating";
import { excludedRealms, isGlobalSearchEnabled } from "helpers/ladder";

const propTypes = {
  clanHomeRealm: PropTypes.string,
  clanBattleRealm: PropTypes.string,
  onRealmChange: PropTypes.func.isRequired,
  itemSelected: PropTypes.string,
  isBrawl: PropTypes.bool
};

class RealmDropdown extends React.Component {


  _getItemContent(realm, tooltip = true) {
    const isGlobalRegion = realm === TYPE_GLOBAL_SEARCH;
    const isHomeRegion = realm === this.props.clanHomeRealm;
    const isBattleRegion = realm === this.props.clanBattleRealm && this.props.isBrawl;
    const isHomeNBattle = isHomeRegion && isBattleRegion;

    const name = isGlobalRegion ? t('Глобальный рейтинг') : settings.realmsMap[realm].name;

    const iconStyles = {};
    iconStyles[styles['icon-globe']] = isGlobalRegion;
    iconStyles[styles['icon-home']] = isHomeRegion;
    iconStyles[styles['icon-fight']] = isBattleRegion;
    iconStyles[styles['icon-home-fight']] = isHomeNBattle;
    iconStyles[styles['has-icon']] = some(Object.keys(iconStyles), k => iconStyles[k]);
    const className = classNames(styles['icon-wrapper'], iconStyles);

    const innerContent = <span className={className}>{t(`${name}`)}</span>;

    let tooltipContent = '';
    if (isHomeNBattle) tooltipContent = t('Домашний и боевой регион вашего клана');else if (isHomeRegion) tooltipContent = t('Домашний регион вашего клана');else if (isBattleRegion) tooltipContent = t('Боевой регион вашего клана');

    // TODO: Add disabled parameter to DivTooltip
    return tooltip && tooltipContent !== '' ? <DivTooltip tooltipBody={<TooltipBody>{tooltipContent}</TooltipBody>}>
            {innerContent}
        </DivTooltip> : innerContent;
  }

  _getItems() {
    let realmsList = [];


    Object.keys(settings.realmsMap).forEach(realm => {
      if (excludedRealms.includes(realm)) {
        return;
      }

      realmsList.push({
        value: realm,
        content: this._getItemContent(realm)
      });
    });

    if (isGlobalSearchEnabled && realmsList.length > 1) realmsList.unshift({
      value: TYPE_GLOBAL_SEARCH,
      content: this._getItemContent(TYPE_GLOBAL_SEARCH)
    });

    return realmsList;
  }

  render() {
    const realmList = this._getItems();
    const itemSelected = realmList.length === 1 && this.props.itemSelected === TYPE_GLOBAL_SEARCH ? realmList[0].value : this.props.itemSelected

    return <div className={styles.container}>
                <Menu items={realmList} itemSelected={itemSelected} onItemChange={this.props.onRealmChange}>
                    <div className={styles.label}>
                        {this._getItemContent(itemSelected, false)}
                    </div>
                </Menu>
            </div>;
  }
}

RealmDropdown.propTypes = propTypes;

export default RealmDropdown;